import React from "react";

import { Box, Typography, TextField } from "@mui/material";

import SelectProject from "./SelectProject";

interface ProjectAndDetailsProps {
  name: string;
  nameError: boolean;
  handleEpisodeNameChange: (event: React.ChangeEvent<HTMLInputElement>) => void;
  selectedProject: { label: string; id: string } | null;
  handleProject: (
    event: React.SyntheticEvent,
    data: { label: string; id: string },
  ) => void;
  projectSelectionError: boolean;
  onCreateProjectClick?: () => void;
  projectsRefreshTrigger?: number;
  autoSelectProjectId?: string | null;
  autoSelectProjectName?: string | null;
  onAutoSelectProjectApplied?: () => void;
}

export default function ProjectAndDetails({
  name,
  nameError,
  handleEpisodeNameChange,
  selectedProject,
  handleProject,
  projectSelectionError,
  onCreateProjectClick,
  projectsRefreshTrigger = 0,
  autoSelectProjectId = null,
  autoSelectProjectName = null,
  onAutoSelectProjectApplied,
}: ProjectAndDetailsProps) {
  return (
    <Box sx={{ width: "100%" }}>
      <Typography
        variant="h5"
        sx={{
          mb: 1,
          textAlign: "left",
          color: "#23272E",
          fontWeight: 700,
        }}
      >
        Episode Details
      </Typography>
      <Typography
        variant="body2"
        sx={{ mb: 3, color: "text.secondary", lineHeight: 1.5 }}
      >
        Name your episode and choose which project it belongs to.
      </Typography>

      {/* Episode Name */}
      <Box sx={{ mb: 3 }}>
        <Typography
          variant="subtitle1"
          sx={{ mb: 1.5, color: "#23272E", fontWeight: 600, fontSize: "1rem" }}
        >
          Episode name
        </Typography>
        <TextField
          fullWidth
          value={name}
          onChange={handleEpisodeNameChange}
          error={nameError}
          helperText={nameError ? "Episode name is required" : ""}
          placeholder="Enter episode name..."
          inputProps={{
            "data-testid": "episode-name-input",
            "aria-label": "Episode name",
          }}
          sx={{
            "& .MuiOutlinedInput-root": {
              borderRadius: "8px",
              "&:hover fieldset": { borderColor: "#2563eb" },
              "&.Mui-focused fieldset": { borderColor: "#2563eb" },
            },
          }}
        />
      </Box>

      {/* Project Selection */}
      <Box sx={{ mb: 0 }}>
        <Typography
          variant="subtitle1"
          sx={{ mb: 1.5, color: "#23272E", fontWeight: 600, fontSize: "1rem" }}
        >
          Project
        </Typography>
        <SelectProject
          handleOnChange={handleProject}
          hasError={projectSelectionError}
          value={selectedProject}
          onCreateProjectClick={onCreateProjectClick}
          projectsRefreshTrigger={projectsRefreshTrigger}
          autoSelectProjectId={autoSelectProjectId}
          autoSelectProjectName={autoSelectProjectName}
          onAutoSelectProjectApplied={onAutoSelectProjectApplied}
        />
      </Box>
    </Box>
  );
}
